import { Box } from '@mui/material'

export const FlexGrow = () => {
    return <Box sx={{ flexGrow: '1' }} />
}
